import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useTheme } from "@mui/styles";
import { AccentInfo } from "../../StyledComponents";
import { dropdownStyles, dropdownMenuProps } from "../../componentThemes";

const MortgageDropdown = ({ value, handleChange, items, disabled, origin }) => {
  const theme = useTheme()
  const dropdown = dropdownStyles(theme)

  return (
    <FormControl className={dropdown.formControl} style={{width: origin === 'financials' ? "32rem" : "40rem", margin: origin === 'financials' ? '0.5rem auto 0 1rem' : '4rem auto 0 auto'}}>
      <Select
        disabled={disabled}
        value={value ? value : 'empty'}
        onChange={handleChange}
        MenuProps={dropdownMenuProps}
        classes={{
          select: dropdown.select,
          icon: dropdown.selectIcon
        }}
      >
        <MenuItem
          value={'empty'}
        >
          <AccentInfo style={{fontSize: '1.2rem'}}>select a property</AccentInfo>
        </MenuItem>
        {items.length > 0 ?
          items.map((mortgage) => (
            <MenuItem
              key={mortgage._id}
              disabled={value === mortgage._id}
              value={mortgage._id}
            >
              {mortgage.streetAddress}
            </MenuItem>
          ))
        :
          <MenuItem disabled>
            <AccentInfo>
              No mortgages uploaded
            </AccentInfo>
          </MenuItem>
        }
      </Select>
    </FormControl>
  )
}

export default MortgageDropdown